// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2cKmR","inputDescription":"styles_inputDescription__1UmPb"};